import { observer } from 'mobx-react-lite'
import React, { useEffect, useRef, useState } from 'react'
import { FiChevronLeft } from 'react-icons/fi'

import ComponentTitle from '../components/templates/ComponentTitle'
import BannerSwiperComponent from '../components/templates/bannerSwiperComponent.jsx'
import BottomBarComponent from '../components/templates/BottomBarComponent'
import MainNovelComponent from '../components/templates/mainNovelComponent.jsx'
import backendApis from '../utils/backendApis.jsx'
import { useNavigate } from 'react-router-dom'
import ToastStore from '../stores/ToastStore'
import LoadingIndicator from '../components/atoms/loadingIndicator'
import UserStore from '../stores/UserStore'

const AltoonNovelPage = observer(() => {
  const navigate = useNavigate()

  const [novelData, setNovelData] = useState()
  const [bannerData, setBannerData] = useState()

  useEffect(() => {
    const fetchNovelData = async () => {
      // 작품 정보 가져오기
      const novelInfo = await backendApis.loadAllNovels()
      if (novelInfo?.status === 200) {
        setNovelData(novelInfo.data)
      } else {
        ToastStore.toastOn({
          type: 'error',
          message: '알 수 없는 오류가 발생했어요.\n 잠시후 다시 시도해주세요',
          duration: 2000,
        })
      }
    }
    const fetchBannerData = async () => {
      // 배너 정보 가져오기
      const bannerData = await backendApis.loadBannerData()
      if (bannerData?.status === 200) {
        const filteredBannerData = bannerData?.data?.filter(
          (banner) =>
            banner?.bannerType === `novel_banner` &&
            banner?.itemId?.toString() !== '65e0160e3401440ed9cecde3'
        )
        setBannerData(filteredBannerData)
      }
    }
    UserStore.setIsLoaded(false)
    fetchNovelData()
    fetchBannerData()
    UserStore.setIsLoaded(true)
  }, [])

  useEffect(() => {}, [])

  const HeaderComponent = () => {
    return (
      <section className="z-10 py-2 flex flex-row items-center justify-between overflow-hidden">
        <button
          aria-label="goBack"
          type="button"
          className="mx-2 p-2 whitespace-nowrap"
          onClick={async () => {
            navigate(-1)
          }}
        >
          <FiChevronLeft className="w-8 h-8 stroke-[0.2vw]" />
        </button>
        <div className="flex font-bold">소설</div>
        <div className="w-16" />
      </section>
    )
  }

  if (!UserStore.isLoaded) {
    return <LoadingIndicator isLoading />
  }

  return (
    <div className="w-full overflow-y-scroll" style={{ height: '100vh' }}>
      <HeaderComponent />
      {bannerData?.length > 0 && (
        <div className="w-[92vw] ml-[4vw]">
          <BannerSwiperComponent bannerData={bannerData} bannerType="toon" />
        </div>
      )}
      {!bannerData && (
        <div className="w-[92vw] ml-[4vw]">
          <BannerSwiperComponent empty bannerType="toon" />
        </div>
      )}

      <div className="mx-[4vw] py-[4vw]">
        <ComponentTitle text="웹소설 신작!" />

        {novelData?.map((novel, index) => (
          <div key={novel?._id} className="mb-[4vw]">
            <MainNovelComponent novel={novel} index={index} type="" />
          </div>
        ))}
      </div>

      <div className="h-[20vw]" />
      <BottomBarComponent />
      {/* {isLoading && <LoadingIndicator />} */}
    </div>
  )
})

export default AltoonNovelPage
